import React, { useEffect, useState } from "react";
import axios from "axios";
import store from "store";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useStudentData from "../../Dashboard/Components/useStudentData";
import TestTypeButtons from "./TestTypeButtons";
import TestDetailsAccordion from "./TestDetailsAccordion";
import institutes from "../../../common/institutes";
import { Box } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  List,
  ListItem,
  ListItemText,
  Card,
  TextField,
} from "@material-ui/core";
import Filters from "../../ExamAnalysis/Filters";
import ResultHeader from "../../resultPage/ResultHeader";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import NoResultMsg from "../../resultPage/NoResultMsg";
import { getTimeSpentPerSubjectAllTests } from "../../resultPage/TimeSpentMultipleTests";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "20px",
    marginRight: "20px",
  },
  card: {
    background: "#EBEFF3",
    boxShadow: `4px 4px 8px rgba(189, 194, 199, 0.75),
                    8px 8px 12px rgba(189, 194, 199, 0.25),
                   -4px -4px 8px rgba(255, 255, 255, 0.75),
                   -8px -8px 12px rgba(255, 255, 255, 0.25)`,
    borderRadius: "16px",
    maxWidth: "100%",
    overflow: "auto",
  },
  radioLabel: {
    color: "#2A2A2A",
    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px", // Tablet
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px", // Desktop
    },
    fontWeight: 700,
    lineHeight: "20px",
  },
}));

export default function ProgressCard() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const user = store.get("user");
  const level = query.get("level");
  const account = query.get("accountType");
  const userLevel = level || (user && user.level);
  const accountType = account || (user && user.accountType);
  const [studentAdmissionNo, omrNo, stuFeeData, avatar] = useStudentData();
  const [fetchedData, setFetchedData] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles(isMobile);
  const presentSummary = [];
  const absentSummary = [];
  const [data1, setData1] = useState([]);
  const [avgData, setAvgData] = useState([]);
  const [testTypes, setTestTypes] = useState([]);
  const [selectedTestType, setSelectedTestType] = useState(0);
  const [viewMode, setViewMode] = useState("present"); // State to manage view mode
  const instituteId = store.get("user").institute;
  const [loading, setLoading] = useState(false);
  const [dataProcessing, setDataProcessing] = useState(false);
  const [absentTestNames, setAbsentTestNames] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [timeSpentData, setTimeSpentData] = useState({});
  const [data, setData] = useState({});

  const [selectedDateValue, setSelectedDateValue] = useState("last4Exams");
  const [selectedExams, setSelectedExams] = useState([]);
  const [selectedExamType, setSelectedExamType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [examTypeOptions, setExamTypeOptions] = useState([]);

  /* async function fetchData() {
    const id = store.get("user").accountType
      ? studentAdmissionNo
      : store.get("user").userId;
    const instituteId = store.get("user").institute;
    const today = new Date();
    const endDate = new Date(today);
    endDate.setMonth(today.getMonth() - 3);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startDateFormatted = formatDate(today);
    const endDateFormatted = formatDate(endDate);
    const datesParam = JSON.stringify({
      startDate: endDateFormatted,
      endDate: startDateFormatted,
    });

    try {
      setLoading(true);
      const response = await axios.get(
        `https://${
          institutes[instituteId]
        }/api/analysis/studentTestRecords/${id}?dates=${encodeURIComponent(
          datesParam
        )}&instituteId=${instituteId}`
      );

      if (response.data) {
        setFetchedData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }*/

  function calculateDates(selectedDateValue) {
    // Example: last 7 days for demonstration
    if (selectedDateValue === "customRange") {
      const today = new Date();
      const priorDate = new Date();
      priorDate.setDate(today.getDate() - 7);
      return {
        startDate: priorDate.toISOString().split("T")[0],
        endDate: today.toISOString().split("T")[0],
      };
    }
    // Add more logic as needed for other custom ranges
    return {};
  }

  const buildPayload = () => {
    let dates = {};
    let examsCount = "";
    if (fromDate && toDate) {
      dates = { startDate: fromDate, endDate: toDate };
    } else if (selectedDateValue) {
      if (selectedDateValue === "customRange") {
        dates = calculateDates(selectedDateValue);
      } else {
        switch (selectedDateValue) {
          case "last1Exams":
            examsCount = "1_exams";
            break;
          case "last4Exams":
            examsCount = "4_exams";
            break;
          case "last8Exams":
            examsCount = "8_exams";
            break;
          case "last16Exams":
            examsCount = "16_exams";
            break;
          case "last20Exams":
            examsCount = "20_exams";
            break;
          case "tillNow":
            examsCount = "all";
            break;
          default:
            examsCount = "4_exams";
        }
      }
    }
    const parsedTests =
      typeof selectedExams === "string"
        ? selectedExams.split(",").map((t) => t.trim())
        : selectedExams;

    return {
      dates: JSON.stringify(dates),
      examtype: selectedExamType,
      student_id: studentAdmissionNo || store.get("user").userId,
      tests: parsedTests,
      examsCount,
      branch: user && user.branchId ? user.branchId : "",
      instituteId,
    };
  };
  async function fetchData() {
    const id = store.get("user").accountType
      ? studentAdmissionNo
      : store.get("user").userId;

    const params = buildPayload();
    // Remove empty params for cleaner URL
    Object.keys(params).forEach(
      (key) =>
        (params[key] === "" || params[key] === "[]") && delete params[key]
    );

    try {
      setLoading(true);
      const queryString = new URLSearchParams(params).toString();

      const response = await axios.get(
        `https://${
          institutes[instituteId]
        }/api/analysis/getPerformanceReport/${id}?${queryString}`
      );

      if (response.data) {
        setFetchedData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchTimeSpentData() {
    const id = store.get("user").accountType
      ? studentAdmissionNo
      : store.get("user").userId;

    const today = new Date();
    const endDate = new Date(today);
    endDate.setMonth(today.getMonth() - 3);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startDateFormatted = formatDate(today);
    const endDateFormatted = formatDate(endDate);
    const datesParam = JSON.stringify({
      startDate: endDateFormatted,
      endDate: startDateFormatted,
    });

    try {
      const response = await axios.post(
        `https://${
          institutes[instituteId]
        }/api/analysis/getStudentQuestionBehaviours/${id}?dates=${encodeURIComponent(
          datesParam
        )}&instituteId=${instituteId}`
      );
      setData(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching time spent data:", error);
      throw error;
    }
  }

  const handleDateChange = (value) => {
    setSelectedDateValue(value);
    setSelectedExams([]);
  };

  const handleExamsChange = (value) => {
    if (Array.isArray(value)) {
      setSelectedExams(value);
    } else {
      const currentIndex = selectedExams.indexOf(value);
      const newChecked = [...selectedExams];
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setSelectedExams(newChecked);
    }
  };

  const handleExamTypeChange = (value) => {
    setSelectedExamType(value);
    setSelectedExams([]);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };

  useEffect(() => {
    if (
      fetchedData &&
      fetchedData.writtenExamTypes &&
      Array.isArray(fetchedData.writtenExamTypes)
    ) {
      setExamTypeOptions([...fetchedData.writtenExamTypes]);
    }
  }, [fetchedData]);

  useEffect(() => {
    fetchData();
  }, [selectedDateValue, selectedExams, selectedExamType, fromDate, toDate]);

  useEffect(() => {
    if (
      fetchedData &&
      !fetchedData.isLoading &&
      fetchedData.output &&
      fetchedData.output.results &&
      selectedExams.length === 0
    ) {
      const results = fetchedData.output.results || [];

      const latestExams = results
        .slice()
        .sort((a, b) => new Date(b.startDateTime) - new Date(a.startDateTime))
        .map((exam) => exam.test_name);

      setSelectedExams(latestExams);
    }
  }, [fetchedData]);

  useEffect(() => {
    setDataProcessing(true);
    if (studentAdmissionNo.length !== 0) {
      fetchData();
      fetchTimeSpentData();
      setDataProcessing(false);
    }
  }, [studentAdmissionNo]);

  useEffect(() => {
    if (fetchedData.output) {
      if (fetchedData.output.averages) {
        const selectedExamType = fetchedData.output.averages;
        setAvgData(selectedExamType);
      }
    }
  }, [fetchedData]);

  useEffect(() => {
    if (fetchedData.output) {
      if (fetchedData.output.results) {
        const finishedTests = fetchedData.output.results.filter(
          (item) => item.test_status === "FINISHED"
        );
        const absentTestNames = fetchedData.output.results.filter(
          (item) => item.test_status === "NOT_STARTED"
        );

        setAbsentTestNames(absentTestNames);

        const testTypes = fetchedData.output.results.map((test) => {
          if (
            test.test_type === "JEE MAINS" ||
            test.test_type === "JEEMAIN_2025" ||
            test.test_type === "JEEMAIN_2022"
          ) {
            return "JEE MAINS";
          }
          return test.test_type;
        });
        setTestTypes([...new Set(testTypes)]);

        const testNames = finishedTests.reduce((acc, obj) => {
          acc[obj.testDisplayName] = obj.test_name || "";
          return acc;
        }, {});

        setData1(finishedTests);
        const notStartedTests = fetchedData.output.results.filter(
          (item) => item.test_status === "NOT_STARTED"
        );
        notStartedTests.map((tests) => {
          const date = new Date(tests.startDateTime).getMonth();
          absentSummary.push(date);
        });

        finishedTests.map((tests) => {
          const date = new Date(tests.startDateTime).getMonth();
          presentSummary.push(date);
        });
      }
    }
  }, [fetchedData]);

  useEffect(() => {
    if (data) {
      const timeSpentData = getTimeSpentPerSubjectAllTests(data.payload);
      setTimeSpentData(timeSpentData);
    }
  }, [data]);

  const normalizeTestType = (type) => {
    if (
      type === "JEE MAINS" ||
      type === "JEEMAIN_2025" ||
      type === "JEEMAIN_2022"
    ) {
      return "JEE MAINS";
    }
    return type;
  };

  const filteredPresentTests = data1.filter((test) =>
    test.testDisplayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // const filteredAbsentTests = absentTestNames
  //   .filter((test) => test.test_type === testTypes[selectedTestType])
  //   .filter((test) =>
  //     test.testDisplayName.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  const filteredAbsentTests = absentTestNames
    .filter(
      (test) =>
        normalizeTestType(test.test_type) ===
        normalizeTestType(testTypes[selectedTestType])
    )
    .filter((test) =>
      test.testDisplayName.toLowerCase().includes(searchTerm.toLowerCase())
    );

  if (
    [
      "211210",
      "2119710",
      "X0210767",
      "X0210766",
      "X0210765",
      "X0210764",
    ].includes(`${userLevel}`) &&
    accountType !== "parent"
  )
    return <NoResultMsg header />;

  return (
    <div>
      {loading || dataProcessing ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <ResultHeader
            testDisplayName="View Progress Card"
            path="/home-page"
          />
          {fetchedData.output && fetchedData.output.results.length === 0 && (
            <Typography
              variant="h6"
              color="error"
              align="center"
              style={{ marginTop: "100px" }}
            >
              No Test data available
            </Typography>
          )}
          <TestTypeButtons
            onSelectTestType={setSelectedTestType}
            testTypes={testTypes}
            selectedTestType={selectedTestType}
          />

          <div className={classes.root}>
            {fetchedData.output && fetchedData.output.results.length !== 0 && (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="viewMode"
                      name="viewMode"
                      value={viewMode}
                      color="primary"
                      onChange={(e) => setViewMode(e.target.value)}
                      row
                      style={{ flex: "none" }}
                    >
                      <FormControlLabel
                        value="present"
                        control={<Radio color="primary" />}
                        label="Present"
                        className={classes.radioLabel}
                      />
                      <FormControlLabel
                        value="absent"
                        control={<Radio color="primary" />}
                        label="Absent"
                        className={classes.radioLabel}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <TextField
                  label="Search Tests"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    marginTop: "10px",
                    borderRadius: "16px",
                  }}
                />
              </>
            )}
          </div>
          <div style={{ paddingBottom: "80px" }}>
            {viewMode === "present" ? (
              <>
                <TestDetailsAccordion
                  selectedTestType={selectedTestType}
                  testDetails={filteredPresentTests}
                  testTypes={testTypes}
                  avgData={avgData}
                  timeSpentData={timeSpentData}
                />
              </>
            ) : (
              <div className={classes.root}>
                <Card className={classes.card}>
                  {viewMode === "absent" && filteredAbsentTests.length > 0 && (
                    <List>
                      <Typography variant="h6" align="center">
                        Absent Tests -{" "}
                        <b style={{ color: "#FC5132" }}>
                          {filteredAbsentTests.length}
                        </b>
                      </Typography>
                      {filteredAbsentTests.map((test, index) => (
                        <ListItem key={index}>
                          <ListItemText
                            style={{ fontSize: "12px" }}
                            primary={
                              <React.Fragment>
                                <b>{index + 1}</b>
                                {`. ${test.testDisplayName}`}
                              </React.Fragment>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Card>
              </div>
            )}
          </div>
          <Box
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingBottom: "16px",
            }}
          >
            <Filters
              selectedDateValue={selectedDateValue || ""}
              selectedExams={selectedExams || []}
              onDateChange={handleDateChange}
              onExamsChange={handleExamsChange}
              onExamTypeChange={handleExamTypeChange}
              selectedExamType={selectedExamType || ""}
              examTypeOptions={examTypeOptions || []}
              exams={(fetchedData && fetchedData.testsList) || []}
              fromDate={fromDate}
              toDate={toDate}
              onFromDateChange={handleFromDateChange}
              onToDateChange={handleToDateChange}
            />
          </Box>
        </>
      )}
    </div>
  );
}

/* import React, { useEffect, useState } from "react";
import axios from "axios";
import store from "store";
import { useLocation } from "react-router-dom";
import useStudentData from "../../Dashboard/Components/useStudentData";
import TestTypeButtons from "./TestTypeButtons";
import TestDetailsAccordion from "./TestDetailsAccordion";
import institutes from "../../../common/institutes";
import { Box } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  List,
  ListItem,
  ListItemText,
  Card,
  TextField,
} from "@material-ui/core";
import Filters from "../../ExamAnalysis/F
import ResultHeader from "../../resultPage/ResultHeader";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import NoResultMsg from "../../resultPage/NoResultMsg";
import { getTimeSpentPerSubjectAllTests } from "../../resultPage/TimeSpentMultipleTests";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "20px",
    marginRight: "20px",
  },
  card: {
    background: "#EBEFF3",
    boxShadow: `4px 4px 8px rgba(189, 194, 199, 0.75),
                    8px 8px 12px rgba(189, 194, 199, 0.25),
                   -4px -4px 8px rgba(255, 255, 255, 0.75),
                   -8px -8px 12px rgba(255, 255, 255, 0.25)`,
    borderRadius: "16px",
    maxWidth: "100%",
    overflow: "auto",
  },
  radioLabel: {
    color: "#2A2A2A",
    fontSize: "14px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px", // Tablet
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px", // Desktop
    },
    fontWeight: 700,
    lineHeight: "20px",
  },
}));

export default function ProgressCard() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const user = store.get("user");
  const level = query.get("level");
  const account = query.get("accountType");
  const userLevel = level || (user && user.level);
  const accountType = account || (user && user.accountType);
  const [studentAdmissionNo, omrNo, stuFeeData, avatar] = useStudentData();
  const [fetchedData, setFetchedData] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles(isMobile);
  const presentSummary = [];
  const absentSummary = [];
  const [data1, setData1] = useState([]);
  const [avgData, setAvgData] = useState([]);
  const [testTypes, setTestTypes] = useState([]);
  const [selectedTestType, setSelectedTestType] = useState(0);
  const [viewMode, setViewMode] = useState("present"); // State to manage view mode
  const instituteId = store.get("user").institute;
  const [loading, setLoading] = useState(false);
  const [dataProcessing, setDataProcessing] = useState(false);
  const [absentTestNames, setAbsentTestNames] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [timeSpentData, setTimeSpentData] = useState({});
  const [data, setData] = useState({});

  async function fetchData() {
    const id = store.get("user").accountType
      ? studentAdmissionNo
      : store.get("user").userId;
    const instituteId = store.get("user").institute;
    const today = new Date();
    const endDate = new Date(today);
    endDate.setMonth(today.getMonth() - 3);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startDateFormatted = formatDate(today);
    const endDateFormatted = formatDate(endDate);
    const datesParam = JSON.stringify({
      startDate: endDateFormatted,
      endDate: startDateFormatted,
    });

    try {
      setLoading(true);
      const response = await axios.get(
        `https://${
          institutes[instituteId]
        }/api/analysis/studentTestRecords/${id}?dates=${encodeURIComponent(
          datesParam
        )}&instituteId=${instituteId}`
      );

      if (response.data) {
        setFetchedData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchTimeSpentData() {
    const id = store.get("user").accountType
      ? studentAdmissionNo
      : store.get("user").userId;

    const today = new Date();
    const endDate = new Date(today);
    endDate.setMonth(today.getMonth() - 3);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const startDateFormatted = formatDate(today);
    const endDateFormatted = formatDate(endDate);
    const datesParam = JSON.stringify({
      startDate: endDateFormatted,
      endDate: startDateFormatted,
    });

    try {
      const response = await axios.post(
        `https://${
          institutes[instituteId]
        }/api/analysis/getStudentQuestionBehaviours/${id}?dates=${encodeURIComponent(
          datesParam
        )}&instituteId=${instituteId}`
      );
      setData(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching time spent data:", error);
      throw error;
    }
  }

  useEffect(() => {
    setDataProcessing(true);
    if (studentAdmissionNo.length !== 0) {
      fetchData();
      fetchTimeSpentData();
      setDataProcessing(false);
    }
  }, [studentAdmissionNo]);

  useEffect(() => {
    if (fetchedData.output) {
      if (fetchedData.output.averages) {
        const selectedExamType = fetchedData.output.averages;
        setAvgData(selectedExamType);
      }
    }
  }, [fetchedData]);

  useEffect(() => {
    if (fetchedData.output) {
      if (fetchedData.output.results) {
        const finishedTests = fetchedData.output.results.filter(
          (item) => item.test_status === "FINISHED"
        );
        const absentTestNames = fetchedData.output.results.filter(
          (item) => item.test_status === "NOT_STARTED"
        );

        setAbsentTestNames(absentTestNames);

        const testTypes = fetchedData.output.results.map((test) => {
          if (
            test.test_type === "JEE MAINS" ||
            test.test_type === "JEEMAIN_2025" ||
            test.test_type === "JEEMAIN_2022"
          ) {
            return "JEE MAINS";
          }
          return test.test_type;
        });
        setTestTypes([...new Set(testTypes)]);

        const testNames = finishedTests.reduce((acc, obj) => {
          acc[obj.testDisplayName] = obj.test_name || "";
          return acc;
        }, {});

        setData1(finishedTests);
        const notStartedTests = fetchedData.output.results.filter(
          (item) => item.test_status === "NOT_STARTED"
        );
        notStartedTests.map((tests) => {
          const date = new Date(tests.startDateTime).getMonth();
          absentSummary.push(date);
        });

        finishedTests.map((tests) => {
          const date = new Date(tests.startDateTime).getMonth();
          presentSummary.push(date);
        });
      }
    }
  }, [fetchedData]);

  useEffect(() => {
    if (data) {
      const timeSpentData = getTimeSpentPerSubjectAllTests(data.payload);
      setTimeSpentData(timeSpentData);
    }
  }, [data]);

  const filteredPresentTests = data1.filter((test) =>
    test.testDisplayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredAbsentTests = absentTestNames
    .filter((test) => test.test_type === testTypes[selectedTestType])
    .filter((test) =>
      test.testDisplayName.toLowerCase().includes(searchTerm.toLowerCase())
    );

  if (
    [
      "211210",
      "2119710",
      "X0210767",
      "X0210766",
      "X0210765",
      "X0210764",
    ].includes(`${userLevel}`) &&
    accountType !== "parent"
  )
    return <NoResultMsg header />;

  return (
    <div>
      {loading || dataProcessing ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <ResultHeader
            testDisplayName="View Progress Card"
            path="/home-page"
          />
          {fetchedData.output && fetchedData.output.results.length === 0 && (
            <Typography
              variant="h6"
              color="error"
              align="center"
              style={{ marginTop: "100px" }}
            >
              No Test data available
            </Typography>
          )}
          <TestTypeButtons
            onSelectTestType={setSelectedTestType}
            testTypes={testTypes}
            selectedTestType={selectedTestType}
          />

          <div className={classes.root}>
            {fetchedData.output && fetchedData.output.results.length !== 0 && (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="viewMode"
                      name="viewMode"
                      value={viewMode}
                      color="primary"
                      onChange={(e) => setViewMode(e.target.value)}
                      row
                      style={{ flex: "none" }}
                    >
                      <FormControlLabel
                        value="present"
                        control={<Radio color="primary" />}
                        label="Present"
                        className={classes.radioLabel}
                      />
                      <FormControlLabel
                        value="absent"
                        control={<Radio color="primary" />}
                        label="Absent"
                        className={classes.radioLabel}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <TextField
                  label="Search Tests"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    marginTop: "10px",
                    borderRadius: "16px",
                  }}
                />
              </>
            )}
          </div>

          {viewMode === "present" ? (
            <>
              <TestDetailsAccordion
                selectedTestType={selectedTestType}
                testDetails={filteredPresentTests}
                testTypes={testTypes}
                avgData={avgData}
                timeSpentData={timeSpentData}
              />
            </>
          ) : (
            <div className={classes.root}>
              <Card className={classes.card}>
                {viewMode === "absent" && filteredAbsentTests.length > 0 && (
                  <List>
                    <Typography variant="h6" align="center">
                      Absent Tests -{" "}
                      <b style={{ color: "#FC5132" }}>
                        {filteredAbsentTests.length}
                      </b>
                    </Typography>
                    {filteredAbsentTests.map((test, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          style={{ fontSize: "12px" }}
                          primary={
                            <React.Fragment>
                              <b>{index + 1}</b>
                              {`. ${test.testDisplayName}`}
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </Card>
            </div>
          )}
        </>
      )}
    </div>
  );
}*/
